<main-frame-layout #layout>
	<div class="content-area">
		<h1>Welcome!</h1>
		<p>Welcome to Dedicaid! Your account has been created successfully.</p>
		<p>We recommend that you <a href="javascript:" (click)="layout.open2FASettings()">enable Two-Factor Authentication</a> for greater security.</p>
	</div>
</main-frame-layout>
